<template>

    <form v-on:submit.prevent="done()" class="modal-card" style="min-width: 10em;">
        
        <section class="modal-card-body">
            
            <button
                type="button"
                class="delete is-pulled-right"
                @click="$emit('close')"/>
    
            <h3 class="title is-3">
                Define the output labels (or categories)
            </h3>
            
            <b-image
            :src="require('@/images/training-example.svg')"
            
            ></b-image>
            
            <LabelsDefine :labelingMode="labelingMode" :project="project" :projectDocuments="projectDocuments"/>
            
            <b-button
                v-if="labelingMode"
                type="is-primary"
                label="Done"
                @click="$emit('close')"
                expanded />
            <b-button v-else
                tag="button"
                native-type="submit"
                label="Done"
                type="is-primary"
                expanded />
                
    
        </section>
        
    </form>
</template>
<script>
import { uuid } from 'vue-uuid'; 
import LabelsDefine from '@/components/LabelsDefine.vue'

export default {
       props: ["project", "projectDocuments", "labelingMode"],
      data() {
        return {
          new_label: null,
        };
      },
      components: {
        LabelsDefine
      },
      created() {
      },
      computed: {

      },
      methods: {
            done(){
                setTimeout(() => 
                    this.$router.push(`/projects/${this.project.id}/train`), 
                1)
            },
            getLabelCodePlusOne(){
                if (this.getLabels() != undefined && this.getLabels().length){
                    return this.project.labels.map(({ label_code }) => parseInt(label_code)).sort((a, b) => a - b).at(-1)+1
                } else {
                    return 1
                }
            },
            getLabels(){
                return this.project.labels
            },
            renameLabel(){
                
                let update = {
                        labels: this.project.labels
                }

                const toUpdate = {
                    projectId: this.project.id,
                    update: update
                    
                }
                
                this.$store.dispatch("updateProject", 
                    toUpdate
                );
            },
            removeLabel(idx){

                this.project.labels = this.project.labels.filter(item => item.label_code !== idx)

                let update = {
                        labels: this.project.labels
                }

                const toUpdate = {
                    projectId: this.project.id,
                    update: update
                    
                }

                console.log(toUpdate)
                
                this.$store.dispatch("updateProject", 
                    toUpdate
                );
            },
            addLabel(){
                if (this.project.labels != undefined){
                    this.project.labels.push({label_code: this.getLabelCodePlusOne(), label: this.new_label})
                } else {
                    this.project.labels = []
                    this.project.labels.push({label_code: this.getLabelCodePlusOne(), label: this.new_label})
                }
                
                let current_labels_name = this.project.labels.map(({ label }) => label);
                
                let update = [];
                try {
                    this.project.new_labels = this.project.new_labels.filter(item => !current_labels_name.includes(item) )
                    update = {
                        labels: this.project.labels,
                        new_labels: this.project.new_labels
                    }
                } catch {
                    update = {
                        labels: this.project.labels
                    }
                }

                const toUpdate = {
                    projectId: this.project.id,
                    update: update
                    
                }
                console.log(toUpdate)
                this.$store.dispatch("updateProject", 
                    toUpdate
                );
                console.log(this.project.labels)
                this.new_label = null
            }
        }
    }
    </script>